require('flickity-fullscreen');
require('flickity-as-nav-for');
import React, { useState } from 'react';
import Flickity from 'react-flickity-component';
import { isArray, map, hasIn } from 'lodash';
import common from '../../../common/common';
import {
    showOverlay,
    hideOverlay,
} from '../../../services/product/productInteraction.js';
import ProductFullScreenHandler from './ProductFullScreenHandler.jsx';
import './ProductCarousel.scss';

const ProductCarousel = (props) => {
    const [flktyRef, setFlktyRef] = useState(undefined);
    const [fullScreenActive, setFullScreenActive] = useState(false);
    const [indexZoom, setIndexZoom] = useState(0);

    const handleMouseEnter = (e) => {
        showOverlay(e, props.isMobile);
    };

    const handleMouseLeave = (e) => {
        hideOverlay(e, props.isMobile);
    };

    const itemsByCarouselSizeHtml = ({ items, carouselSize }) =>
        map(items, (item, index) => {
            return (
                <div
                    key={index}
                    className={
                        carouselSize === 'browse'
                            ? 'carousel-small-cell'
                            : 'carousel-large-cell'
                    }
                    data-type={item.type}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}>
                    <img
                        src={common.contentFromCdn({
                            path: item.imageUrl,
                            keepUrlAsIs: false,
                        })}
                    />
                    <div />
                </div>
            );
        });

    const itemsZoom = (items) =>
        map(items, (item) => ({ type: 'image', src: item['zoom'] }));

    const carouselFullscreen = (propsItems, carouselSize) => {
        if (!isArray(propsItems) || carouselSize === undefined) {
            return [];
        }

        const items = map(propsItems, (item) => ({
            imageUrl: item[carouselSize],
            type: carouselSize,
        }));
        return itemsByCarouselSizeHtml({
            items,
            carouselSize,
        });
    };

    if (flktyRef) {
        flktyRef.on('staticClick', (event, pointer, cellElement, cellIndex) => {
            if (!cellElement) {
                return;
            }
            const type = hasIn(cellElement, 'dataset.type')
                ? cellElement.dataset.type
                : undefined;
            if (type && type === 'big' && fullScreenActive === false) {
                setIndexZoom(cellIndex);
                setFullScreenActive(!fullScreenActive);
            }
        });
    }
    return (
        <>
            {fullScreenActive && (
                <ProductFullScreenHandler
                    options={{
                        infinite: false,
                        on: {
                            closing: (fancybox, slide) => {
                                setFullScreenActive(false);
                            },
                        },
                        startIndex: indexZoom,
                    }}
                    items={itemsZoom(
                        props.carousel
                    )}></ProductFullScreenHandler>
            )}
            {
                <Flickity
                    className={props.carouselSize}
                    flickityRef={(c) => {
                        setFlktyRef(c);
                    }}
                    options={props.flcktyOption}>
                    {carouselFullscreen(props.carousel, props.carouselSize)}
                </Flickity>
            }
        </>
    );
};

export default ProductCarousel;
